import Hero from "@/components/Hero";
import About from "@/components/About";
import Services from "@/components/Services";
import { Link } from "react-router-dom";
import { whatsappUrl, teleconsultUrl } from "@/lib/constants";
import { ArrowUpRight, Video } from "lucide-react";
import usePageTitle from "@/lib/usePageTitle";

export default function HomePage() {
  usePageTitle();
  return (
    <>
      <Hero />
      <About />
      <Services variant="preview" />

      <section
        data-testid="home-cta-band"
        className="bg-[#0A2540] text-white"
      >
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-20 lg:py-28 grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-8">
            <div className="font-mono text-[10px] uppercase tracking-widest-plus text-[#B08A4A] mb-4">
              Two paths — one standard of care
            </div>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.05]">
              For patients seeking clarity.
              <br />
              <span className="italic text-[#B08A4A]">
                For institutions seeking rigor.
              </span>
            </h2>
          </div>
          <div className="lg:col-span-4 flex flex-col gap-4">
            <a
              href={teleconsultUrl()}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="cta-band-book"
              className="group inline-flex items-center justify-between gap-3 bg-white text-[#0A2540] hover:bg-[#B08A4A] hover:text-white px-6 py-5 text-xs tracking-widest-plus uppercase transition-all"
            >
              <span className="inline-flex items-center gap-2">
                <Video size={16} strokeWidth={1.5} />
                Book Online Teleconsultation
              </span>
              <ArrowUpRight size={16} strokeWidth={1.5} />
            </a>
            <a
              href={whatsappUrl()}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="cta-band-lab"
              className="group inline-flex items-center justify-between gap-3 bg-transparent text-white border border-white/40 hover:bg-white/10 px-6 py-4 text-[11px] tracking-widest-plus uppercase transition-all"
            >
              Lab Tests &amp; Home Collection
              <ArrowUpRight size={14} strokeWidth={1.5} />
            </a>
            <Link
              to="/b2b"
              data-testid="cta-band-b2b"
              className="group inline-flex items-center justify-between gap-3 bg-transparent text-white border border-[#B08A4A] hover:bg-[#B08A4A]/10 px-6 py-4 text-[11px] tracking-widest-plus uppercase transition-all"
            >
              B2B &amp; Research Solutions
              <ArrowUpRight size={14} strokeWidth={1.5} />
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
